export default __webpack_public_path__ + "static/media/operator.b59c3aec.png";